import { render, staticRenderFns } from "./videoLogo.vue?vue&type=template&id=4a051742&scoped=true"
var script = {}
import style0 from "./videoLogo.vue?vue&type=style&index=0&id=4a051742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a051742",
  null
  
)

export default component.exports